import script from "./transfer-index.vue?vue&type=script&setup=true&lang=js"
export * from "./transfer-index.vue?vue&type=script&setup=true&lang=js"

import "./transfer-index.vue?vue&type=style&index=0&id=5fedef09&lang=css"

const __exports__ = script;

export default __exports__